import DeepLinkInsightRedirect from '../../components/Insights/components/DeepLinkInsightRedirect';
import PublicInsightDetailsView from '../../components/Insights/components/PublicInsightDetailsView';
import Page404 from '../../pages/Page404';
import { createCrumbHandle } from '../../utilities/auth';

const publicRoutes = [
  {
    path: '/shared/insightsDetails',
    element: <DeepLinkInsightRedirect />,
    handle: createCrumbHandle('Insight Details'),
  },
  {
    path: '/shared/insight/:insightId/:shareCode?',
    element: <PublicInsightDetailsView />,
    handle: createCrumbHandle('Public Insight Details'),
  },
  {
    path: '/shared/*',
    element: <Page404 />,
    handle: createCrumbHandle('Page Not Found'),
  },
];

export default publicRoutes;
